import API from '@/lib/API.js'
import comun from './comun.js'
const patologias = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        }
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Patologias.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let motivo = state.Lista.find((x) => x.id_patologia == payload)
            commit("select", motivo)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_patologia: 0,
                descripcion_patologia: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_patologia != 0) {
                data = await API.Patologias.modificar(state.Seleccionado);
                str += "Patologia modificada"
            } else {
                data = await API.Patologias.alta(state.Seleccionado);
                str += `nueva Patologia de alta '${data.descripcion_patologia}'`
            }
            let secs = await API.Patologias.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_patologia)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch,
            state
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.id_patologia != 0) {
                data = await API.Patologias.modificar(entidad);
                str += "Patologia modificada"
            } else {
                data = await API.Patologias.alta(entidad);
                str += `nueva Patologia de alta '${data.descripcion_patologia}'`
            }
            let ents = await API.Patologias.traerTodos();
            commit("set", ents)
            //commit("select", data)
            dispatch("selectPorId", data.id_patologia)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Patologias.eliminar(id);
                str += "Patologia eliminada"
            }
            let ents = await API.Patologias.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default patologias;